import { ROUTES } from './routes';

export const menuItems = [
  {
    title: 'Home',
    url: `${ROUTES.home}`,
  },
  {
    title: 'About',
    url: `${ROUTES.about}`,
  },
  {
    title: 'Services',
    submenu: [
      {
        title: 'Trademark Registration',
        url: `${ROUTES.trademarkRegistration}`,
      },
      {
        title: 'Comprehensive Trademark Search',
        url: `${ROUTES.comprehensiveSearch}`,
      },
      {
        title: 'Free Trademark Search',
        url: `${ROUTES.search}`,
      },
      {
        title: 'Statement of Use',
        url: `${ROUTES.statementOfUse}`,
      },
      {
        title: 'Trademark Monitoring',
        url: `${ROUTES.trademarkMonitoring}`,
      },
      {
        title: 'Office Action Response',
        url: `${ROUTES.officeActionResponse}`,
      },
      {
        title: 'Filing a Renewal',
        url: `${ROUTES.renewal}`,
      },
      {
        title: 'Request for Extension',
        url: `${ROUTES.requestForExtension}`,
      },
      {
        title: 'Revival From Abandonment',
        url: `${ROUTES.revivalFromAbandonment}`,
      },
      {
        title: 'Logo Design Service',
        url: `${ROUTES.logoDesignService}`,
      },
    ],
  },
  {
    title: 'FAQs',
    url: `${ROUTES.faq}`,
  },
  {
    title: 'Our Guarantee',
    url: `${ROUTES.guarantee}`,
  },
];
